var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-search-title"},[_c('h1',{staticClass:"hiq-h1 hiq-search-title__text"},[_vm._v(" Sökresultat för \" "+_vm._s(_vm.query)+" \" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }